(function () {
    $(document).ready(function () {
        const giftStr = `
        <div class="gift-entry">
            <span>
                <span class="gift-icon"></span>
                Receive a gift with purchase of $259 >>
            </span>
        </div>
        `
        if (is_open_gift) {
            $('.is-color, .free_shipping_box').after(giftStr)
        }
        $(document).on('click', '.gift-entry', function () {
            $('.gift-dialog-wrap').show()
        })
        $(document).on('click', '.gift-wrap-close', function () {
            $('.gift-dialog-wrap').hide()
        })
    })
})()